import { render, staticRenderFns } from "./users-details.vue?vue&type=template&id=396811cc&scoped=true"
import script from "./users-details.vue?vue&type=script&lang=js"
export * from "./users-details.vue?vue&type=script&lang=js"
import style0 from "./users-details.vue?vue&type=style&index=0&id=396811cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396811cc",
  null
  
)

export default component.exports